import React from "react";
import type { TextColor } from "@/app/types/ui";

interface HeadingTwoProps {
  children: React.ReactNode;
  color?: TextColor; // Pass the Tailwind text-color class you need
}

export const HeadingTwo = ({
  children,
  color = "text-black",
}: HeadingTwoProps) => {
  return <h2 className={`text-2xl font-bold ${color}`}>{children}</h2>;
};
